import * as React from 'react';
import { SVGProps } from 'react';

const Refresh = (props: SVGProps<SVGSVGElement>) => (
  <svg width={12} height={16} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M6 4v2l2.667-2.667L6 .667v2A5.332 5.332 0 0 0 .667 8c0 1.047.306 2.02.826 2.84l.974-.973A3.914 3.914 0 0 1 2 8c0-2.207 1.793-4 4-4Zm4.507 1.16-.974.973C9.827 6.693 10 7.327 10 8c0 2.207-1.793 4-4 4v-2l-2.667 2.667L6 15.333v-2A5.332 5.332 0 0 0 11.333 8c0-1.047-.306-2.02-.826-2.84Z'
      fill='#000'
    />
  </svg>
);

export default Refresh;
